
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { fr, es, enUS } from "date-fns/locale";

interface AnalysisHeaderProps {
  onBackToHome: () => void;
  analysisDate?: string | null;
}

const AnalysisHeader = ({ onBackToHome, analysisDate }: AnalysisHeaderProps) => {
  const { t, i18n } = useTranslation('ai-analysis');
  const dateLocale = i18n.language === 'fr' ? fr : i18n.language === 'es' ? es : enUS;

  return (
    <div className="flex items-center justify-between print:block">
      <div>
        <h1 className="text-3xl font-bold text-golf-800">{t('header.title')}</h1>
        <p className="text-gray-600">{t('header.subtitle')}</p>
        {analysisDate && (
          <div className="flex items-center gap-2 mt-2 text-sm text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>
              {format(new Date(analysisDate), 'PPP', { locale: dateLocale })}
            </span>
          </div>
        )}
      </div>
      <Button onClick={onBackToHome} variant="outline" className="print:hidden">
        <ArrowLeft className="h-4 w-4 mr-2" />
        {t('actions.backToHome')}
      </Button>
    </div>
  );
};

export default AnalysisHeader;
